
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/leadership",
      function () {
        return require("private-next-pages/about/leadership.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/leadership"])
      });
    }
  